import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Spin } from "antd";
import { checkPermissions } from "@comps/commonFunctions";

const PermissionGuard = ({
  modkey,
  action = "view",
  children,
  fallback = null,
  redirectTo = "/dashboard",
  mode = "route",
}) => {
  const location = useLocation();
  const allowed = checkPermissions(modkey, action);

  if (allowed === null) {
    return (
      <div style={ { minHeight: 160, display: "flex", alignItems: "center", justifyContent: "center" } }>
        <Spin />
      </div>
    );
  }

  if (!allowed) {
    if (mode === "inline") {
      return fallback;
    }

    return <Navigate to={ redirectTo } replace state={ { deniedFrom: location.pathname } } />;
  }

  return children;
};

export const PermissionOnly = ({ children, ...props }) => (
  <PermissionGuard { ...props } mode="inline">
    { children }
  </PermissionGuard>
);

export const guardElement = (element, modkey, action = "view") => (
  <PermissionGuard modkey={ modkey } action={ action }>
    { element }
  </PermissionGuard>
);

export default PermissionGuard;
